const cart = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_CART':
      return action.cart || [];
    default:
      return state;
  }
};
export default cart;
